import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconPackage, IconTag } from '@tabler/icons-react';
import { lazy } from 'react';

/**
 * Модуль Catalog — справочники каталога, товаров и брендов.
 * Регистрирует группу меню «Каталог» с пунктами «Товары» и «Бренды».
 */
export async function setup(app: AppRuntime): Promise<void> {
  const catalog = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  const groupCatalog = catalog.createNavigationGroup({
    key: 'catalog',
    label: 'Каталог',
    icon: IconPackage,
    order: 1,
  });

  catalog.useNavigation([
    {
      group: groupCatalog,
      icon: IconPackage,
      label: 'Товары',
      // URL прежний: по нему ходят закладки, и на него настроено активное
      // состояние пункта.
      url: '/catalog/products',
      component: lazy(() => import('./components/CatalogTreeView')),
    },
    {
      group: groupCatalog,
      icon: IconTag,
      label: 'Бренды',
      url: '/catalog/brands',
      component: lazy(() =>
        import('./components/Brands/BrandsList').then(m => ({ default: m.BrandsList }))
      ),
    },
  ]);
}
